module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert fade in m-b-15",
    class: {
      'alert-danger': _vm.isError, 'alert-success': !_vm.isError
    }
  }, [_vm._v("\n  " + _vm._s(_vm.message) + "\n  "), _c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closed')
      }
    }
  }, [_vm._v("×")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3daf9fae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Alert.vue
// module id = 1325
// module chunks = 0